<!--数字区间选择-->
<template>
  <el-form
    :disabled="disabled"
    ref="form"
    class="number-Interval"
    inline
    :model="form"
    :rules="rules"
  >
    <el-form-item prop="min">
      <el-input
        :placeholder="text[0]"
        v-model="form.min"
        @change="handleMinChange"
      />
    </el-form-item>
    <div class="number-Interval-mark">{{ rangeSeparator || '-' }}</div>
    <el-form-item prop="max">
      <el-input
        :placeholder="text[1]"
        v-model="form.max"
        @change="handleMaxChange"
      />
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  props: {
    range: {
      default: function() {
        return [0, 100];
      },
      type: Array
    },
    text: {
      default: function() {
        return ['请输入开始数字', '请输入结束数字'];
      },
      type: Array
    },
    rangeSeparator: {
      type: String,
      default: '-'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'numberInterval',
  data() {
    return {
      form: { min: '', max: '' },
      rules: {
        min: [
          { validator: this.validateCom, trigger: 'blur' },
          { validator: this.validateMin, trigger: 'blur' }
        ],
        max: [
          { validator: this.validateCom, trigger: 'blur' },
          { validator: this.validateMax, trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    getFormData() {
      const ret = {};
      this.$refs.form.validate(valid => {
        ret.valid = valid;
        ret.form = this.form;
      });
      return ret;
    },
    resetForm() {
      this.$refs.form.resetFields();
    },
    handleMinChange() {
      this.$refs.form.validateField('max');
      this.handleChange();
    },
    handleMaxChange() {
      this.$refs.form.validateField('min');
      this.handleChange();
    },
    handleChange() {
      this.$refs.form.validate(valid => {
        if (valid) {
          let value = [
            this.form.min === '' && this.form.max === ''
              ? this.form.min
              : +this.form.min,
            this.form.max === '' ? this.form.max : +this.form.max
          ];
          this.$emit('change', value);
          this.$emit('success');
        } else {
          this.$emit('change', ['', '']);
          this.$emit('error');
        }
      });
    },
    validateCom(rule, value, callback) {
      const one = value;
      let nub = /(^[0-9]*$)|(^[0-9]*[\.]{1}[0-9]{1,2}$)/;
      if (!nub.test(value)) {
        callback(new Error('必须是整数或不超过两位的小数'));
      } else {
        if (one < this.range[0]) {
          return callback(new Error(`输入值必须大于${this.range[0]}`));
        } else if (one > this.range[1]) {
          return callback(new Error(`输入值必须小于或等于${this.range[1]}`));
        }
        return callback();
      }
    },
    validateMin(rule, value, callback) {
      const one = Number(value);
      const max = Number(this.form.max);
      if (!max || one <= max) {
        return callback();
      } else if (max == one) {
        return callback(new Error('不能和最大值相等'));
      } else if (one > max) {
        return callback(new Error(`不能大于${max}`));
      }

      callback(new Error(`输入值应在${this.range[0]}~${this.range[1]}之间`));
    },
    validateMax(rule, value, callback) {
      const one = Number(value);
      const min = Number(this.form.min);
      if (!min || one >= min) {
        return callback();
      } else if (min == one) {
        return callback(new Error('不能和最小值相等'));
      } else if (one < min) {
        return callback(new Error(`不能小于${min}`));
      }
      return callback(
        new Error(`输入值应在${this.range[0]}~${this.range[1]}之间`)
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.number-Interval {
  //display: flex;
  .el-form-item {
    margin-bottom: 0;
  }
  &-mark {
    line-height: 40px;
    margin-right: 10px;
    display: inline-block;
  }
  padding: 0;
}
</style>
